module.exports = __webpack_public_path__ + "static/media/grey-snake.7fb7cd10.png";